export const CYBER_MONDAY_SALE_20_OFF_2022 = 'cyber_monday_sale_20_off_2022'
